export const CLEAR_ORIGINATOR_MANAGEMENT_STATE = 'CLEAR_ORIGINATOR_MANAGEMENT_STATE';

export const GET_ALL_ORIGINATORS = 'GET_ALL_ORIGINATORS';
export const GET_ALL_ORIGINATORS_SUCCESS = 'GET_ALL_ORIGINATORS_SUCCESS';
export const GET_ALL_ORIGINATORS_ERROR = 'GET_ALL_ORIGINATORS_ERROR';

export const GET_ORIGINATOR_BY_ID = 'GET_ORIGINATOR_BY_ID';
export const GET_ORIGINATOR_BY_ID_SUCCESS = 'GET_ORIGINATOR_BY_ID_SUCCESS';
export const GET_ORIGINATOR_BY_ID_ERROR = 'GET_ORIGINATOR_BY_ID_ERROR';

export const CREATE_ORIGINATOR = 'CREATE_ORIGINATOR';
export const CREATE_ORIGINATOR_SUCCESS = 'CREATE_ORIGINATOR_SUCCESS';
export const CREATE_ORIGINATOR_ERROR = 'CREATE_ORIGINATOR_ERROR';

export const UPDATE_ORIGINATOR = 'UPDATE_ORIGINATOR';
export const UPDATE_ORIGINATOR_SUCCESS = 'UPDATE_ORIGINATOR_SUCCESS';
export const UPDATE_ORIGINATOR_ERROR = 'UPDATE_ORIGINATOR_ERROR';

export const DELETE_ORIGINATOR = 'DELETE_ORIGINATOR';
export const DELETE_ORIGINATOR_SUCCESS = 'DELETE_ORIGINATOR_SUCCESS';
export const DELETE_ORIGINATOR_ERROR = 'DELETE_ORIGINATOR_ERROR';

export const GET_ORIGINATORS_STATUS = 'GET_ORIGINATORS_STATUS';
export const GET_ORIGINATORS_STATUS_SUCCESS = 'GET_ORIGINATORS_STATUS_SUCCESS';
export const GET_ORIGINATORS_STATUS_ERROR = 'GET_ORIGINATORS_STATUS_ERROR';

export const GET_OFFER_BY_ORIGINATOR = 'GET_OFFER_BY_ORIGINATOR';
export const GET_OFFER_BY_ORIGINATOR_SUCCESS = 'GET_OFFER_BY_ORIGINATOR_SUCCESS';
export const GET_OFFER_BY_ORIGINATOR_ERROR = 'GET_OFFER_BY_ORIGINATOR_ERROR';

export const GET_ALL_INDUSTRY = 'GET_ALL_INDUSTRY';
export const GET_ALL_INDUSTRY_SUCCESS = 'GET_ALL_INDUSTRY_SUCCESS';
export const GET_ALL_INDUSTRY_ERROR = 'GET_ALL_INDUSTRY_ERROR';

export const GET_ALL_DOC_TYPE = 'GET_ALL_DOC_TYPE';
export const GET_ALL_DOC_TYPE_SUCCESS = 'GET_ALL_DOC_TYPE_SUCCESS';
export const GET_ALL_DOC_TYPE_ERROR = 'GET_ALL_DOC_TYPE_ERROR';

export const GET_ALL_DOC_SUBTYPE = 'GET_ALL_DOC_SUBTYPE';
export const GET_ALL_DOC_SUBTYPE_SUCCESS = 'GET_ALL_DOC_SUBTYPE_SUCCESS';
export const GET_ALL_DOC_SUBTYPE_ERROR = 'GET_ALL_DOC_SUBTYPE_ERROR';

export const GET_ALL_USERS_BY_ORIGINATOR = 'GET_ALL_USERS_BY_ORIGINATOR';
export const GET_ALL_USERS_BY_ORIGINATOR_SUCCESS = 'GET_ALL_USERS_BY_ORIGINATOR_SUCCESS';
export const GET_ALL_USERS_BY_ORIGINATOR_ERROR = 'GET_ALL_USERS_BY_ORIGINATOR_ERROR';
